import { render, staticRenderFns } from "./CombinationsProductsControls.vue?vue&type=template&id=52a20b4b&scoped=true"
import script from "./CombinationsProductsControls.vue?vue&type=script&setup=true&lang=ts"
export * from "./CombinationsProductsControls.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CombinationsProductsControls.vue?vue&type=style&index=0&id=52a20b4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a20b4b",
  null
  
)

export default component.exports